import { computed, makeObservable, observable } from 'mobx';

import { Step } from './step';
import { Strip } from './strip';

export class ShootingDay extends Step {
  strips: Strip[] = [];
  dod: number;

  get daybreakId() {
    return this.strips.find((strip) => strip.type === 'dayBreak')?._id || '';
  }

  constructor() {
    super();

    makeObservable(this, {
      strips: observable,
      dod: observable,
      daybreakId: computed,
    });
  }
}
